<template>
    <div class="w-full">

        <h4 class="mb-3">Timeshift Channels</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addTimeshiftChannelPrompt = true">Add</vs-button>

        <vx-card id="channelsDiv"  class="vs-con-loading__container">

            <vs-table ref="table" @selected="openTimeshiftChannel" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="worker_channel_name">Channel</vs-th>
                    <vs-th sort-key="channel_worker_name">Channel Worker</vs-th>
                    <vs-th sort-key="worker_name">Recording Worker</vs-th>
                    <vs-th sort-key="retention_days">Retention days</vs-th>
                    <vs-th sort-key="override_link">Override link</vs-th>
                    <vs-th sort-key="enabled">Enabled</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].worker_channel_name">
                            {{ data[index].worker_channel_name }}
                        </vs-td>

                        <vs-td :data="data[index].channel_worker_name">
                            {{ data[index].channel_worker_name }}
                        </vs-td>

                        <vs-td :data="data[index].worker_name">
                            {{ data[index].worker_name }}
                        </vs-td>

                        <vs-td :data="data[index].retention_days">
                            {{ data[index].retention_days }}
                        </vs-td>

                        <vs-td :data="data[index].override_link">
                            <vs-chip v-if="!data[index].override_link" color="danger">No</vs-chip>
                            <p v-else>{{ data[index].link }}</p>
                        </vs-td>

                        <vs-td :data="data[index].enabled">
                            <vs-chip v-if="data[index].enabled" color="success">Yes</vs-chip>
                            <vs-chip v-else color="danger">No</vs-chip>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup title="Add timeshift channel" :active.sync="addTimeshiftChannelPrompt">
            <div id="addChannelDiv" class="vs-con-loading__container" >
                <vs-checkbox class="mt-3" v-model="addObject['enabled']">Enabled</vs-checkbox>
                <p class="mt-6">Retention days</p>
                <vs-input v-model="addObject['retention_days']" class="w-full"></vs-input>
                <p class="mt-6">Worker Channel</p>
                <vs-select autocomplete class="w-full" v-model="addObject['worker_channel_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name + ' - ' + item.worker_name" v-for="(item,index) in worker_channels" />
                </vs-select>
                <p class="mt-6">Recording Worker</p>
                <vs-select autocomplete class="w-full" v-model="addObject['worker_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workers" />
                </vs-select>
                <div class="vx-row">
                    <div class="vx-col w-4/12 mt-6">
                        <vs-checkbox class="mt-6" v-model="addObject['override_link']">Override link</vs-checkbox>
                    </div>
                    <div class="vx-col w-8/12">
                        <p class="mt-6">Link</p>
                        <vs-input :disabled="!addObject['override_link']" v-model="addObject['link']" class="w-full"></vs-input>
                    </div>
                </div>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addTimeshiftChannel">Add</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

export default {
    data(){
        return {

            itemsPerPage: 20,
            isMounted: false,

            channels: [],
            workers: [],
            worker_channels: [],

            addTimeshiftChannelPrompt: false,

            addObject: {}

        }
    },
    methods: {
        openTimeshiftChannel(tr){
            this.$router.push("/timeshift_channel/" + tr.id)
        },
        loadData() {
            this.$vs.loading({
                container: '#channelsDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const loadPromise = this.$http.get('/api/management/v1/timeshift/')
            loadPromise.then(function(response) {
                thisIns.channels = response.data
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            })

            const workersPromise = this.$http.get('/api/management/v1/worker/?type=adopted')
            workersPromise.then(function(response) {
                thisIns.workers = response.data
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            })

            const workerChannelsPromise = this.$http.get('/api/management/v1/worker_channel/')
            workerChannelsPromise.then(function(response) {
                thisIns.worker_channels = response.data
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            })

            Promise.all([loadPromise, workersPromise, workerChannelsPromise]).finally(function() {
                thisIns.$vs.loading.close('#channelsDiv > .con-vs-loading')
            })
        },
        addTimeshiftChannel() {
            this.$vs.loading({
                container: '#addChannelDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this

            const addPromise = this.$http.post('/api/management/v1/timeshift/', {
                enabled: this.addObject.enabled,
                retention_days: Number(this.addObject.retention_days),
                worker_channel_id: Number(this.addObject.worker_channel_id),
                worker_id: Number(this.addObject.worker_id),
                override_link: this.addObject.override_link,
                link: this.addObject.link,
            })

            addPromise.then(function(response) {
                thisIns.addTimeshiftChannelPrompt = false
                thisIns.$printSuccess('Timeshift Channel added')
                thisIns.$nextTick(() => {
                    thisIns.$router.push("/timeshift_channel/" + response.data.id)
                })
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#addChannelDiv > .con-vs-loading')
            })
        },
    },
    computed: {
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx
            }
            return 0
        },
        tableItems() {
            if (this.isMounted) {
                return this.$refs.table.queriedResults.length
            }
            return 0
        },
        tableData() {
            return this.channels
        }
    },
    mounted() {
        this.isMounted = true
        this.loadData()
    }
}

</script>
